import React from 'react'
import Header from '../../headerone/Main'
import Breadcrumb from '../../Breadcrumb/Main'
import MscEle from './MscEle'


function Main() {
    return (
        <>
            <Header />
            <Breadcrumb title="Home" subtitle="Admission"/>
            <MscEle/>
        </>
    )
}

export default Main